import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserInvitationReply } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_reply';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_invitation_reply = createAsyncThunkSafe<void, RequestWorkspaceUserInvitationReply>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_REPLY,
  async (request: RequestWorkspaceUserInvitationReply): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_REPLY, request);
  },
);

export function init_remote_workspace_user_invitation_reply(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_invitation_reply.pending, (state, action) => {})
    .addCase(remote_workspace_user_invitation_reply.rejected, (state, action) => {})
    .addCase(remote_workspace_user_invitation_reply.fulfilled, (state, action: PayloadAction) => {});
}
